import { useShallow } from 'zustand/react/shallow'
import { useZugnummerStore } from '@/store/useZugnummerStore'
import { BfnStoreDataEntry } from '@/store/useBfnStore'
import { BfnStatus } from '@/models/Befehlsnachricht'
import { useHasDeadlinePassed } from '@repo/ui'

export default function useIsErledigenActionBlocked(
  entry: BfnStoreDataEntry
): boolean {
  const zugnummer = useZugnummerStore(useShallow((state) => state.zugnummer))
  const deadlinePassed = useHasDeadlinePassed(
    entry.befehlsnachricht.bearbeitbarBis
  )

  const isErledigenActionBlocked =
    entry.befehlsnachricht.status === BfnStatus.QUITTIERT &&
    !deadlinePassed &&
    String(entry.befehlsnachricht.zugnummer) !== zugnummer

  return isErledigenActionBlocked
}
